import "bootstrap/dist/css/bootstrap.min.css";
import "css/material-dashboard.css";
// import "jquery";
// import "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "css/index.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "App";
import * as serviceWorker from "serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
